import React from "react";
import Layout from "../components/Layout";

export default function Privacy() {
  return (
    <Layout>
      <div className="section-pad max-w-3xl mx-auto">
        <h1 className="font-display text-4xl font-semibold text-brand-ink">Privacy Policy</h1>
        <div className="mt-6 space-y-4 text-brand-inksoft leading-relaxed">
          <p>Isoharts respects your privacy. We collect only the information necessary to provide your membership, deliver content, process consultations, and send you the communications you opt into.</p>
          <p>We never sell your personal data. Payment processing is handled by a PCI-compliant provider; we do not store raw card details on our servers.</p>
          <p>You may request access to, correction of, or deletion of your data at any time by emailing <a href="mailto:seymour@isoharts.com" className="text-brand-sage underline">seymour@isoharts.com</a>.</p>
          <p>Cookies and local storage are used to keep you signed in and remember your progress. You can clear these at any time from your browser.</p>
        </div>
      </div>
    </Layout>
  );
}
